









import { Component, Vue, Prop } from "vue-property-decorator";
import { IMerchantInShops } from "@/store/interfaces/shops.ts";

@Component({
  name: "ListShops"
})
export default class ListShops extends Vue {
  @Prop({ default: null })
  merchant: IMerchantInShops;

  elepsize: boolean = false;

  truncateText() {
    if (this.$refs.title["offsetWidth"] < this.$refs.title["scrollWidth"]) {
      this.$refs.title["classList"].add("overflow");
      this.elepsize = true;
    } else {
      this.$refs.title["classList"].add("not-overflow");
    }
  }

  mounted() {
    this.truncateText();
  }
}
